export const API_VERSION = 'beta';
export const GRAPH_URL = 'https://graph.microsoft.com/';
export const RESOURCE_NOTFOUND_ERRCODE = 'Request_ResourceNotFound';
